import { Characteristic } from 'enums/characteristic';
import * as CharacteristicToggle from 'types/_general/Search/CharacteristicToggle';

export type Type = CharacteristicToggle.Type[];

export function create(): Type {
	return [];
}

export function initialize(): Type {
	const result: Type = [];
	for (const i of Object.keys(Characteristic)) {
		result.push({ id: i, name: i });
	}
	return result;
}

export function mapToStringList(obj: Type): string[] {
	return obj.map((x: CharacteristicToggle.Type) => x.id);
}
